import React, { Component } from 'react';
import lang from '../lang/index';
import url from 'c-url';

import Contact from './contact';

class VerifySuccess extends Component {
    render() {
        const fea = url.query('feature');
        const isHujing = fea == 224;
        const isUpVoice = fea == 226;

        let tip = lang.template("赶快返回Up直播中与全球潮人互动吧！");
        if (isHujing) {
            tip = lang.template("赶快返回虎鲸直播中与全球潮人互动吧");
        } else if (isUpVoice) {
            tip = lang.template("赶快返回UpVoice中与全球潮人互动吧");
        }
        let appName = url.query('appname') || null;
        return (
            <div>
                {appName ? null : <div className={isHujing ? 'hujing-logo' : 'logo'}></div>}
                <div className="verify-result">
                    <div className={isHujing ? "verifylogo success-hj" : "verifylogo success"}></div>
                    <div className="notice">
                        <h2>{lang.template("验证成功")}</h2>
                        <p>{lang.template("恭喜您已成功激活帐户")}</p>
                        <p>{tip}</p>
                    </div>
                </div>
                <Contact />
            </div>
        );
    }

}


export default VerifySuccess;



// WEBPACK FOOTER //
// ./js/view/verify-success.js